import api from "@/config/api"
const platform = localStorage.getItem('platform')

export default {
    components: {
    },
    model: {
        prop: 'url',
        event: 'change'
    },
    props: ['url', 'num', 'data'],
    data () {
        return {
            maxNum: 1,
            headers: {},
            uploadUrl: `${api.baseUrl}/${platform}/open/upload_file`,
            loading: false,
            previewVisible: false,
            previewImage: '',
            fileList: [],
        }
    },
    computed: {
    },
    watch: {
        url(value) {
            if (this.fileList.length > 0) {
                return
            }
            const items = typeof(value) === 'string' ? [value] : value
            this.setUrl(items)
        },
        fileList: {
            handler(items) {
                let urls = []
                for (let i = 0; i < items.length; i++) {
                    let item = items[i]
                    const response = item.response
                    const message = response && response.message || '上传失败'

                    if (item.status === 'done' && response && response.code !== 0) {
                        this.$message.destroy()
                        this.$message.error(message)
                        this.fileList.splice(i, 1)
                        continue
                    }

                    const url = item.url || (response && response.data && response.data.url)

                    if (url) {
                        urls.push(url)
                        items[i] = {
                            uid: item.uid,
                            name: item.name,
                            status: item.status,
                            url: url,
                        }
                    }

                    if (['uploading', 'done'].includes(item.status)) {
                        continue
                    }

                    this.fileList.splice(i, 1)
                    this.$message.destroy()
                    this.$message.error(message)
                }
                if (this.maxNum === 1) {
                    urls = urls[0]
                }
                this.$emit('change', urls)
            },
            deep: true
        }
    },
    mounted () {
        this.url && this.setUrl(this.url)
        this.maxNum = this.num || this.maxNum
        this.headers['Access-Token'] = localStorage.getItem('token')
    },
    methods: {
        handleCancel() {
            this.previewVisible = false
        },
        async handlePreview(file) {
            this.previewImage = file.url || file.response.data.url
            this.previewVisible = true
        },
        handleChange({ fileList }) {
            this.fileList = fileList
        },
        beforeUpload(file) {
            const allowTypes = [
                'image/jpg',
                'image/jpeg',
                'image/png',
                'image/gif',
            ]

            const isImage = allowTypes.includes(file.type)

            if (!isImage) {
                file.response = { code: -1, message: '图片格式错误' }
                return false
            }

            const isLt2M = file.size / 1024 / 1024 < 4;

            if (!isLt2M) {
                file.response = { code: -1, message: '图片大小不能超过 4MB' }
            }

            return !!(isImage && isLt2M)
        },
        setUrl(items) {
            if (!items) {
                return
            }
            if (typeof (items) === 'string') {
                items = [items]
            }
            for (let i = 0; i < items.length; i++) {
                this.fileList.push({
                    uid: (new Date()).getTime() + i,
                    name: 'image.png',
                    status: 'done',
                    url: items[i],
                })
            }
        }
    }
}
